import { render, staticRenderFns } from "./LegalsPopup.vue?vue&type=template&id=44635c7b&scoped=true"
import script from "./LegalsPopup.vue?vue&type=script&lang=js"
export * from "./LegalsPopup.vue?vue&type=script&lang=js"
import style0 from "./LegalsPopup.vue?vue&type=style&index=0&id=44635c7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44635c7b",
  null
  
)

export default component.exports